import { putWithToken, getWithToken } from 'api/network';
import { put, takeEvery, select } from 'redux-saga/effects';
import {
  appNotify,
  updateAssumptionGroup,
  setGroupsAreLoading,
  setSelectedGroupIsDirty,
  setSelectedGroupIsLoading,
  setSelectedGroupId,
  setSelectedModule
} from '../../../store/actions';
import { selectedModuleSelector } from 'store/selectors';

export function* updateAssumptionGroupSaga() {
  yield takeEvery(updateAssumptionGroup, function* ({ payload }) {
    try {
      yield put(setGroupsAreLoading(true));
      yield put(setSelectedGroupIsLoading(true));

      const url = '/api/assumptions/groups';
      yield putWithToken(url, payload);

      yield put(setSelectedGroupId(payload.groupId));
      yield put(setSelectedGroupIsDirty(false));

      yield put(setGroupsAreLoading(false));
      yield put(setSelectedGroupIsLoading(false));

      const selectedModule = yield select(selectedModuleSelector);
      const moduleUrl = `/api/assumptions/modules/${selectedModule.moduleId}`;
      const res = yield getWithToken(moduleUrl);
      const data = yield res.json();

      yield put(setSelectedModule(data));

      yield put(appNotify(`${payload.name} updated`, 'success'));
    } catch (error) {
      yield put(
        appNotify(`Failed to update assumption group: ${error}`, 'error')
      );
      yield put(setGroupsAreLoading(false));
      yield put(setSelectedGroupIsLoading(false));
    }
  });
}
